import { db } from '../firebase'
import { useAuth } from "../contexts/AuthContext"
import '../css/Bet.css'

function Bet(props) {

    const { currentUser } = useAuth();

    function handleDelete() {
        // Zolang de match nog niet begonnen is kan je je bet verwijderen 
        if (props.timestamp > props.bettedTimestamp) {
            db.collection("Players").doc(`${currentUser.uid}`).collection("Bets").doc(`${props.id}`)
                .delete().then(() => {
                    console.log("Fixture successfully deleted!");
                    window.location.reload(true);
                }).catch((error) => {
                    console.error("Error removing Fixture", error);
                });
        }

    }

    // winnerTemId is null wanneer de match niet afgelopen is EN wanneer het gelijkspel is 
    // daarom moeten we een dubbele controle uitvoeren om de juiste weergave te kunnnen displayen (o.a. border-bottom ...)

    if (props.timestamp > Date.now()) {
        return (
                <div className="card me-4 bg-dark text-center" id="card-bet">
                    <div className="row card-header verticalAlign">
                        <div className="col-md-4">
                            <p className="">{props.date} {props.time}</p>
                        </div>
                        <div className="col-md-4">
                            <h6 className="">{props.teams} <br /> {props.league}</h6>
                        </div>
                        <div className="col-md-4">
                            {props.timestamp > Date.now() ? <button className="btn btn-danger" onClick={handleDelete}>Delete Bet</button>
                                : <button className="btn btn-info" disabled> Match is over </button>}
                        </div>
                    </div>
                    <div className="card-body row verticalAlign">
                        <div className="col-md-4">
                            <img src={props.logoLocalTeam} alt="football_team_local" width="60" height="60" />
                        </div>
                        <div className="col-md-4">
                            <p>{props.score}</p>
                        </div>
                        <div className="col-md-4">
                            <img src={props.logoVisitorTeam} alt="football_team_vistor" width="60" height="60" />
                        </div>
                        <div className="col-md-12 text-center">
                            {props.timestamp > Date.now() ? <p className="text-light">You have bet on {props.betDrawOrTeam}</p>
                                : <p className="text-success">You had bet on {props.betDrawOrTeam}</p>}
                        </div>
                    </div>
                </div>
            );
    }

    if (props.winnerTeamId === props.bet) {
        return (
            <div className="card me-4 bg-dark border-bottom-green text-center" id="card-bet">
                <div className="row card-header verticalAlign">
                    <div className="col-md-4">
                        <p className="">{props.date} {props.time}</p>
                    </div>
                    <div className="col-md-4">
                        <h6 className="">{props.teams} <br /> {props.league}</h6>
                    </div>
                    <div className="col-md-4">
                        {props.timestamp > Date.now() ? <button className="btn btn-danger" onClick={handleDelete}>Delete Bet</button>
                            : <button className="btn btn-info" disabled> Match is over </button>}
                    </div>
                </div>
                <div className="card-body row verticalAlign">
                    <div className="col-md-4">
                        <img src={props.logoLocalTeam} alt="football_team_local" width="60" height="60" />
                    </div>
                    <div className="col-md-4">
                        <p>{props.score}</p>
                    </div>
                    <div className="col-md-4">
                        <img src={props.logoVisitorTeam} alt="football_team_vistor" width="60" height="60" />
                    </div>
                    <div className="col-md-12 text-center">
                        {props.timestamp > Date.now() ? <p className="text-light">You have bet on {props.betDrawOrTeam}</p>
                            : <p className="text-success">You had bet on {props.betDrawOrTeam}</p>}
                    </div>
                </div>
            </div>
        );
    }

    if (props.winnerTeamId !== props.bet) {
        return (
            <div className="card me-4 bg-dark border-bottom-red text-center" id="card-bet">
                <div className="row card-header verticalAlign">
                    <div className="col-md-4">
                        <p className="">{props.date} {props.time}</p>
                    </div>
                    <div className="col-md-4">
                        <h6 className="">{props.teams} <br /> {props.league}</h6>
                    </div>
                    <div className="col-md-4">
                        {props.timestamp > Date.now() ? <button className="btn btn-danger" onClick={handleDelete}>Delete Bet</button>
                            : <button className="btn btn-info" disabled> Match is over </button>}
                    </div>
                </div>
                <div className="card-body row verticalAlign">
                    <div className="col-md-4">
                        <img src={props.logoLocalTeam} alt="football_team_local" width="60" height="60" />
                    </div>
                    <div className="col-md-4">
                        <p>{props.score}</p>
                    </div>
                    <div className="col-md-4">
                        <img src={props.logoVisitorTeam} alt="football_team_vistor" width="60" height="60" />
                    </div>
                    <div className="col-md-12 text-center">
                        {props.timestamp > Date.now() ? <p className="text-light">You have bet on {props.betDrawOrTeam}</p>
                            : <p className="text-danger">You had bet on {props.betDrawOrTeam}</p>}
                    </div>
                </div>
            </div>
        );
    }


}

export default Bet;